// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comments_container {
  padding: 16px;
}

.comments_title_container {
  display: flex;
  justify-content: flex-start;
}

.comments_title {
  font-weight: 700;
  font-family: "Kufam", sans-serif;
  margin-top: 10px;
  margin-bottom: 10px;
}

.comments_bordered_div {
  border: 1px solid #e0e0e0;
  padding: 16px;
  margin-bottom: 16px;
  border-radius: 8px;
  box-shadow: 5px 5px 15px 0px rgba(0, 101, 204, 0.15);
}

.comments_input_button_group {
  gap: 8px;
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.comments_primary_input {
  flex: 1;
  border-radius: 8px;
  padding: 8px;
}

.comments_primary_input::placeholder {
  color: lightgray; 
}
.comments_primary_input:disabled::placeholder {
  color: rgb(4, 4, 4); 
  font-weight: bold;
}

.comments_send_button {
  flex: none;
  background-color: #7f847f;
  border-radius: 8px;
}

.comments_send_button:hover {
  background-color: #198cd9;
}

.comment {
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
}

.comment_content {
  padding: 8px 0;
  border-bottom: 1px solid #e0e0e0;
}

.comment_header {
  display: flex;
  align-items: center;
  flex-direction: row;
}

.comment_header .ant-avatar {
  margin-right: 8px;
}

.comment_details {
  margin-left: 8px;
  display: flex;
  flex-direction: column;
}
.comment_details_user_name {
  font-family: Kufam;
  font-weight: 400;
  text-align: left;
  font-size: 14px;
}
.comment_details_time {
  font-family: Kufam;
  font-size: 12px;
}

.comment_body {
  margin-top: 8px;
  margin-left: 5px;
}

.comment_actions {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}

.reply_input_container {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}

.replies {
  margin-left: 32px;
  margin-top: 8px;
}

.reply {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.reply .ant-avatar {
  margin-right: 8px;
}

.reply_details {
  margin-left: 8px;
}
.comments_parent_reply_row_content {
  display: flex;
  flex-direction: row;
}
.comments_parent_comment_text {
  width: 80%;
}
.comments_parent_comment_reply_button {
  width: 20%;
}
.reply_comment_container {
  margin-bottom: 5px;
}
.reply_comment_name_text {
  font-weight: 500;
  font-size: 13px;
}
.reply_comment_date_text {
  font-weight: 400;
  font-size: 13px;
}
.show_all_button_container {
  height: 30px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center !important;
  align-items: center;
}
.see_more_text {
  color: #198cd9;
  cursor: pointer;
}
.see_more_text:hover {
  text-decoration: underline;
}
.comments_skeleton {
  width: 100% !important;
  height: 100% !important;
}
.comments_title_container > h5 {
  font-family: "Kufam";
  font-weight: 800;
}
.reply_comments_skeleton_container {
  height: 100px !important;
  width: 100% !important;
}
.reply_comments_skeleton_profile_wrapper {
  display: flex !important;
  flex-direction: row !important;
}
.reply_comments_skeleton_name {
  margin-left: 5px;
  margin-bottom: 3px;
  height: 20px !important;
}
.ant-skeleton.ant-skeleton-element .ant-skeleton-input {
  min-width: 0px;
}
.reply_comments_skeleton_content {
  width: 90% !important;
  height: 50px !important;
}
.reply_comments_skeleton_info {
  display: flex;
  flex-direction: column;
}
`, "",{"version":3,"sources":["webpack://./src/styles/layout/comments.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,oDAAoD;AACtD;;AAEA;EACE,QAAQ;EACR,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,sBAAsB;AACxB;AACA;EACE,wBAAwB;EACxB,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB","sourcesContent":[".comments_container {\n  padding: 16px;\n}\n\n.comments_title_container {\n  display: flex;\n  justify-content: flex-start;\n}\n\n.comments_title {\n  font-weight: 700;\n  font-family: \"Kufam\", sans-serif;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.comments_bordered_div {\n  border: 1px solid #e0e0e0;\n  padding: 16px;\n  margin-bottom: 16px;\n  border-radius: 8px;\n  box-shadow: 5px 5px 15px 0px rgba(0, 101, 204, 0.15);\n}\n\n.comments_input_button_group {\n  gap: 8px;\n  margin-top: 16px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.comments_primary_input {\n  flex: 1;\n  border-radius: 8px;\n  padding: 8px;\n}\n\n.comments_primary_input::placeholder {\n  color: lightgray; \n}\n.comments_primary_input:disabled::placeholder {\n  color: rgb(4, 4, 4); \n  font-weight: bold;\n}\n\n.comments_send_button {\n  flex: none;\n  background-color: #7f847f;\n  border-radius: 8px;\n}\n\n.comments_send_button:hover {\n  background-color: #198cd9;\n}\n\n.comment {\n  margin-bottom: 16px;\n  display: flex;\n  flex-direction: column;\n}\n\n.comment_content {\n  padding: 8px 0;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.comment_header {\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n}\n\n.comment_header .ant-avatar {\n  margin-right: 8px;\n}\n\n.comment_details {\n  margin-left: 8px;\n  display: flex;\n  flex-direction: column;\n}\n.comment_details_user_name {\n  font-family: Kufam;\n  font-weight: 400;\n  text-align: left;\n  font-size: 14px;\n}\n.comment_details_time {\n  font-family: Kufam;\n  font-size: 12px;\n}\n\n.comment_body {\n  margin-top: 8px;\n  margin-left: 5px;\n}\n\n.comment_actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.reply_input_container {\n  display: flex;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.replies {\n  margin-left: 32px;\n  margin-top: 8px;\n}\n\n.reply {\n  display: flex;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.reply .ant-avatar {\n  margin-right: 8px;\n}\n\n.reply_details {\n  margin-left: 8px;\n}\n.comments_parent_reply_row_content {\n  display: flex;\n  flex-direction: row;\n}\n.comments_parent_comment_text {\n  width: 80%;\n}\n.comments_parent_comment_reply_button {\n  width: 20%;\n}\n.reply_comment_container {\n  margin-bottom: 5px;\n}\n.reply_comment_name_text {\n  font-weight: 500;\n  font-size: 13px;\n}\n.reply_comment_date_text {\n  font-weight: 400;\n  font-size: 13px;\n}\n.show_all_button_container {\n  height: 30px;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: center !important;\n  align-items: center;\n}\n.see_more_text {\n  color: #198cd9;\n  cursor: pointer;\n}\n.see_more_text:hover {\n  text-decoration: underline;\n}\n.comments_skeleton {\n  width: 100% !important;\n  height: 100% !important;\n}\n.comments_title_container > h5 {\n  font-family: \"Kufam\";\n  font-weight: 800;\n}\n.reply_comments_skeleton_container {\n  height: 100px !important;\n  width: 100% !important;\n}\n.reply_comments_skeleton_profile_wrapper {\n  display: flex !important;\n  flex-direction: row !important;\n}\n.reply_comments_skeleton_name {\n  margin-left: 5px;\n  margin-bottom: 3px;\n  height: 20px !important;\n}\n.ant-skeleton.ant-skeleton-element .ant-skeleton-input {\n  min-width: 0px;\n}\n.reply_comments_skeleton_content {\n  width: 90% !important;\n  height: 50px !important;\n}\n.reply_comments_skeleton_info {\n  display: flex;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
